import React from 'react';
import useSmallScreen from 'hooks/useSmallScreen';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import ContactUsButton from './ContactUsButton';

type DialogActionsStylesProps = {
  isSmallScreen: boolean;
};

const useDialogActionsStyles = makeStyles((theme: HCPTheme) => ({
  root: {
    padding: ({ isSmallScreen }: DialogActionsStylesProps) => (isSmallScreen ? theme.spacing(1, 2) : theme.spacing(3)),
  },
}));

const useStyles = makeStyles((theme: HCPTheme) => ({
  buttons: {
    marginLeft: theme.spacing(2),
  },
  needHelp: {
    fontWeight: 'bold',
  },
}));

type Props = {
  cancelButton?: JSX.Element;
  backButton?: JSX.Element;
  submitButton?: JSX.Element;
  noChargeButton?: JSX.Element;
};

export default function PayWallActionsLayout(props: Props): JSX.Element {
  const classes = useStyles();
  const isSmallScreen = useSmallScreen();
  const dialogActionsClasses = useDialogActionsStyles({ isSmallScreen });

  const { cancelButton, backButton, submitButton, noChargeButton } = props;

  if (isSmallScreen) {
    return (
      <>
        <Divider />
        <DialogActions classes={dialogActionsClasses}>
          <Grid container justify="space-between">
            {backButton && <Grid item>{backButton}</Grid>}

            {/* A placeholder to make space-between work and shift submit button to the right on mobile */}
            {!backButton && <Grid item />}

            {submitButton && <Grid item>{submitButton}</Grid>}
          </Grid>
        </DialogActions>
      </>
    );
  }

  return (
    <DialogActions classes={dialogActionsClasses}>
      <Grid container justify="space-between">
        <Grid container item alignItems="center" xs wrap="nowrap">
          <Typography className={classes.needHelp}>Need help with plans?</Typography>
          <Box ml={1} />
          <ContactUsButton label="Contact us." />
        </Grid>
        <Grid container item justify="flex-end" xs={8} wrap="nowrap">
          {cancelButton && (
            <Grid item className={classes.buttons}>
              {cancelButton}
            </Grid>
          )}

          {backButton && (
            <Grid item className={classes.buttons}>
              {backButton}
            </Grid>
          )}

          {noChargeButton && (
            <Grid item className={classes.buttons}>
              {noChargeButton}
            </Grid>
          )}

          {submitButton && (
            <Grid item className={classes.buttons}>
              {submitButton}
            </Grid>
          )}
        </Grid>
      </Grid>
    </DialogActions>
  );
}
